import { z } from 'zod';

export interface Product {
  term: string;
  rate: number;
}

export const RateSchema = z.number().nullable();

export const TermBucketSchema = z.string();

export const SectorBucketRatesSchema = z.record(TermBucketSchema, RateSchema);

export const SectorBucketSchema = z.string();

export const RatingBucketRatesSchema = z.record(
  SectorBucketSchema,
  SectorBucketRatesSchema
);

export const RatingBucketSchema = z.string();

export const CurrencyRatesSchema = z.record(
  RatingBucketSchema,
  RatingBucketRatesSchema
);

export const CurrencySchema = z.string().min(3).max(3);

export const RatesDataSchema = z.record(CurrencySchema, CurrencyRatesSchema);
export type RatesData = z.infer<typeof RatesDataSchema>;

export const RatesQueryResultSchema = z
  .object({
    defaultCurrency: z.string(),
    rates: RatesDataSchema,
    user: z.string(),
    pricing: z.string(),
    exclude: z.array(z.string()),
    yieldConvention: z.string(),
    branding: z.string(),
  })
  .catchall(z.unknown());
export type RatesQueryResult = z.infer<typeof RatesQueryResultSchema>;

export const PdfResponseSchema = z
  .object({
    pdf_base64: z.string(),
  })
  .catchall(z.unknown());
export type PdfResponse = z.infer<typeof PdfResponseSchema>;
